export enum TemplateType {
    Default,
    Custom,
}
